// No top Apollo button
const NoTopApolloButton = () => null;

export default NoTopApolloButton;
